var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "primary-color", attrs: { id: "inspire" } },
    [
      _c(
        "v-content",
        [
          _c(
            "v-layout",
            {
              staticClass: "login-box spacing-playground pa-12",
              attrs: { "align-center": "", "justify-center": "" }
            },
            [
              _c(
                "v-row",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md4: "",
                    justify: "space-around"
                  }
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "login-card primary-color",
                      attrs: { width: "100%", "max-width": "400px" }
                    },
                    [
                      _c("v-row", {
                        attrs: { align: "center", justify: "center" }
                      }),
                      _c(
                        "v-toolbar",
                        { attrs: { color: "toolbarBase", dark: "", flat: "" } },
                        [
                          _c("v-toolbar-title", [_vm._v("Login")]),
                          _c("v-spacer"),
                          _c("v-tooltip", { attrs: { right: "" } }, [void 0], 2)
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue-box white-text",
                              attrs: { tile: "", block: "", type: "submit" },
                              on: { click: _vm.signin }
                            },
                            [
                              _c("v-img", {
                                attrs: {
                                  contain: "",
                                  "max-height": "20px",
                                  "max-width": "40px",
                                  src: require("@/assets/img/microsoft.png")
                                }
                              }),
                              _vm._v("Entrar com Microsoft")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }